/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Tooltip } from '@mui/material';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { CircleButton } from 'src/common/ui/components';

export const NavIconsFeedback = () => (
  <Tooltip title="Give Feedback" placement="bottom">
    <span
      css={css`
        & svg {
          fill: ${Colors.White};
        }
      `}
    >
      <CircleButton
        color="transparent-inverted"
        onClick={() => {
          window.open('https://forms.gle/JfazgwjYPiDDdFQi8', '_blank');
        }}
        icon="speechBubble"
      />
    </span>
  </Tooltip>
);
